"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Expertise() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const paragraphs = ["In the early days of 2022, our founder established Marga Travel with a single desk and a vision to redefine how South Africans explore the globe. We believed that travel should be more than just a booking; it should be a curated narrative, a bridge between cultures, and a seamless journey from the moment you dream of a destination to the moment you return home.", "Our commitment to excellence is reflected in every package we craft. We understand that the modern traveler seeks authenticity, safety, and value. By leveraging our deep-rooted partnerships with global airlines, luxury resorts, and local guides, we provide exclusive access to experiences that are often hidden from the standard tourist path. We don't just sell holidays; we curate memories that last a lifetime.", "As we look toward the future, Marga Travel continues to innovate. From sustainable travel initiatives to advanced digital booking tools, we are dedicated to making your next adventure easier, greener, and more inspiring. Whether you are planning a family getaway, a romantic escape, or a solo expedition, our legacy of trust and expertise is at your service, ensuring every detail is handled with precision."];
  return <section data-section-id="1409" id="global-travel-expertise" className="bg-background text-foreground relative overflow-visible py-24 md:py-36 lg:py-52">
      <div className="mx-auto max-w-[1360px] px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16">
          
          <div ref={leftRef} data-index={0} className="lg:col-span-5 transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] opacity-100 translate-y-0 w-full">
            <div className="lg:sticky lg:top-32">
              
              <div className="relative bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/IMG_8813-scaled.png)] w-full max-w-[310px]">
                <div className="bg-card border border-border p-3 rounded-lg shadow-md w-full h-auto">
                  <div className="relative overflow-hidden aspect-[4/5] rounded-lg">
                    <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1715383/img/IMG_8813.jpg" alt="Marga Travel founder, expert travel consultant" loading="lazy" decoding="async" className="h-full w-full object-cover" style={{
                    filter: "sepia(0.1) saturate(1.1) contrast(1.05)"
                  }} />
                    <div className="pointer-events-none absolute inset-0 mix-blend-multiply opacity-30" style={{
                    background: "linear-gradient(180deg, hsla(206,67%,39%,0.25) 0%, hsla(100,50%,51%,0.15) 50%, hsla(206,67%,39%,0.3) 100%)"
                  }} />
                  </div>
                </div>

                
                <div className="absolute -top-6 -right-4 md:-top-8 md:-right-6 w-24 h-24 md:w-36 md:h-36 pointer-events-none" style={{
                transform: "rotate(-8deg)"
              }} aria-hidden="true">
                  <svg viewBox="0 0 160 160" className="w-full h-full">
                    <defs>
                      <filter id="rough-stamp">
                        <feTurbulence type="fractalNoise" baseFrequency="0.9" numOctaves="2" />
                        <feDisplacementMap in="SourceGraphic" scale="2.5" />
                      </filter>
                      <path id="stamp-curve" d="M 80,80 m -56,0 a 56,56 0 1,1 112,0 a 56,56 0 1,1 -112,0" />
                    </defs>
                    <g filter="url(#rough-stamp)" style={{
                    color: "var(--secondary)"
                  }}>
                      <circle cx="80" cy="80" r="64" fill="none" stroke="currentColor" strokeWidth="2" opacity="0.9" />
                      <circle cx="80" cy="80" r="56" fill="none" stroke="currentColor" strokeWidth="1.2" opacity="0.85" />
                      <text fill="currentColor" style={{
                      fontFamily: "var(--font-default)",
                      fontSize: "10px",
                      letterSpacing: "0.18em",
                      fontWeight: 700
                    }}>
                        <textPath href="#stamp-curve" startOffset="0%">
                          MARGA · EXPERT · EST. 2022 · SA ·
                        </textPath>
                      </text>
                      <text x="80" y="86" textAnchor="middle" fill="currentColor" style={{
                      fontFamily: "var(--font-default)",
                      fontSize: "16px",
                      fontStyle: "italic",
                      fontWeight: 500
                    }}>
                        verified
                      </text>
                    </g>
                  </svg>
                </div>
              </div>

              
              <div className="mt-8 bg-card border border-border p-7 md:p-8 relative rounded-lg shadow-md w-full h-auto max-w-[420px]">
                
                
                

                <h3 className="font-default text-2xl md:text-3xl font-semibold text-foreground leading-tight tracking-tight">MARGA TRAVEL</h3>
                <p className="mt-2 font-default text-xs md:text-sm uppercase text-muted-foreground" style={{
                letterSpacing: "0.12em"
              }}>
                  Expert Consultants
                </p>

                
                <div className="mt-6 mb-6 flex items-center gap-3">
                  <div className="flex-1 h-px bg-border" />
                  <div className="w-1.5 h-1.5 rounded-lg bg-primary" />
                </div>

                
                <ul className="space-y-2 font-default text-muted-foreground text-xs" style={{
                letterSpacing: "0.08em"
              }}>
                  <li className="flex justify-between gap-4">
                    <span className="uppercase opacity-70">FOUNDED</span>
                    <span className="uppercase">2022</span>
                  </li>
                  <li className="flex justify-between gap-4">
                    <span className="uppercase opacity-70">Status</span>
                    <span className="uppercase">ACCREDITTED</span>
                  </li>
                  <li className="flex justify-between gap-4">
                    <span className="uppercase opacity-70">Experience</span>
                    <span className="uppercase">5+ YEARS</span>
                  </li>
                  <li className="flex justify-between gap-4">
                    <span className="uppercase opacity-70">HQ</span>
                    <span className="uppercase">Johannesburg, SA</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          
          <div ref={rightRef} data-index={1} className="lg:col-span-7 relative transition-all duration-700 ease-[cubic-bezier(0.22,1,0.36,1)] delay-100 opacity-100 translate-y-0 w-full">
            
            <div className="font-default text-xs md:text-sm uppercase text-primary mb-8" style={{
            letterSpacing: "0.18em"
          }}> 04 — OUR TRAVEL PHILOSOPHY</div>

            
            <div className="relative">
              <span aria-hidden="true" className="pointer-events-none absolute -top-8 -left-2 md:-top-16 md:-left-6 select-none font-default font-bold leading-none" style={{
              fontSize: "clamp(8rem, 18vw, 18rem)",
              color: "var(--foreground)",
              opacity: 0.05
            }}>
                04
              </span>

              <h2 className="relative font-default font-semibold text-foreground tracking-tight" style={{
              fontSize: "clamp(2.25rem, 4.5vw, 4.5rem)",
              lineHeight: 1.02
            }}>
                Curating journeys across the{" "}
                <em className="font-default not-italic md:italic font-normal" style={{
                color: "var(--primary)"
              }}>
                  globe
                </em>{" "}
                with care.
              </h2>
            </div>

            
            <div className="mt-10 mb-10 flex items-center gap-3">
              <div className="flex-1 h-px bg-border" />
              <div className="w-1.5 h-1.5 bg-secondary rounded-lg" />
            </div>

            
            <div className="max-w-[620px] space-y-7 opacity-95">
              {paragraphs.slice(0, 2).map((p, i) => <p key={i} data-index={i} className="font-default text-foreground" style={{
              fontSize: "clamp(1.0625rem, 1.3vw, 1.25rem)",
              lineHeight: 1.6,
              letterSpacing: "-0.005em"
            }}>{p}</p>)}

              
              <blockquote className="py-6 my-4 max-w-[640px] border-l-2 border-secondary pl-6">
                <p className="font-default italic text-foreground leading-snug" style={{
                fontSize: "clamp(1.5rem, 2.5vw, 2rem)",
                letterSpacing: "-0.015em"
              }}>
                  &ldquo;We don&apos;t just book flights; we craft experiences that{" "}
                  <span style={{
                  color: "var(--primary)"
                }} className="not-italic font-semibold">transform your perspective of the world.</span>
                  &rdquo;
                </p>
                <p className="mt-4 font-default italic text-foreground opacity-80" style={{
                fontSize: "clamp(1.125rem, 1.5vw, 1.25rem)",
                letterSpacing: "-0.015em"
              }}>
                  -Sazi Zondo (Founder & Director)
                </p>
              </blockquote>

              {paragraphs.slice(2).map((p, i) => <p key={i + 2} data-index={i + 2} className="font-default text-foreground" style={{
              fontSize: "clamp(1.0625rem, 1.3vw, 1.25rem)",
              lineHeight: 1.6,
              letterSpacing: "-0.005em"
            }}>{p}</p>)}
            </div>

            
            <div className="mt-12 w-full h-auto">
              <Link to="/DestinationsPage" className="group inline-flex items-baseline font-default italic text-lg md:text-xl relative" style={{
              color: "var(--primary)"
            }}>
                <span className="relative">
                  Explore our holiday packages
                  <span aria-hidden="true" className="absolute left-0 -bottom-1 h-px w-0 group-hover:w-full transition-all duration-300 ease-out" style={{
                  backgroundColor: "var(--primary)"
                }} />
                </span>
                <span aria-hidden="true" className="ml-2 transition-transform duration-200 group-hover:translate-x-1">
                  →
                </span>
              </Link>
            </div>

            
            <div className="hidden md:block absolute top-0 right-0 font-default text-xs uppercase text-muted-foreground" style={{
            letterSpacing: "0.12em"
          }}>UPDATED 2025</div>
          </div>
        </div>
      </div>
    </section>;
}